import { secureFetch } from './secureFetch';

const callGeocodeEndpoint = async (payload) => {
  const res = await secureFetch(process.env.REACT_APP_GOOGLE_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    retries: 1,
    timeout: 10000,
  });
  return res.json();
};

export const googleGeocode = async ({ address, latlng }) => {
  if (!latlng && !address) return null;
  const data = await callGeocodeEndpoint(latlng ? { latlng: String(latlng) } : { address });
  if (data && Array.isArray(data.results)) {
    return data.results.length > 0 ? data.results : null;
  }
  return null;
};
